'use strict';

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var CID = require('cids');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');
/**
 * @typedef {import('../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/block').API<HTTPClientExtraOptions>} BlockAPI
 * @typedef {import('ipfs-core-types/src/block').RmResult} RmResult
 */


module.exports = configure(function (api) {
  /**
   * @type {BlockAPI["rm"]}
   */
  function rm(_x) {
    return _rm.apply(this, arguments);
  }

  function _rm() {
    _rm = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
      var options,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          removed,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (!Array.isArray(cid)) {
                cid = [cid];
              }

              _context.next = 4;
              return _awaitAsyncGenerator(api.post('block/rm', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: cid.map(function (cid) {
                    return new CID(cid).toString();
                  }),
                  'stream-channels': true
                }, options)),
                headers: options.headers
              }));

            case 4:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 7;
              _iterator = _asyncIterator(res.ndjson());

            case 9:
              _context.next = 11;
              return _awaitAsyncGenerator(_iterator.next());

            case 11:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 15;
              return _awaitAsyncGenerator(_step.value);

            case 15:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 23;
                break;
              }

              removed = _value;
              _context.next = 20;
              return toCoreInterface(removed);

            case 20:
              _iteratorNormalCompletion = true;
              _context.next = 9;
              break;

            case 23:
              _context.next = 29;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](7);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 29:
              _context.prev = 29;
              _context.prev = 30;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 34;
                break;
              }

              _context.next = 34;
              return _awaitAsyncGenerator(_iterator.return());

            case 34:
              _context.prev = 34;

              if (!_didIteratorError) {
                _context.next = 37;
                break;
              }

              throw _iteratorError;

            case 37:
              return _context.finish(34);

            case 38:
              return _context.finish(29);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 25, 29, 39], [30,, 34, 38]]);
    }));
    return _rm.apply(this, arguments);
  }

  return rm;
});
/**
 * @param {*} removed
 */

function toCoreInterface(removed) {
  /** @type {RmResult} */
  var out = {
    cid: new CID(removed.Hash)
  };

  if (removed.Error) {
    out.error = new Error(removed.Error);
  }

  return out;
}